import { Network, BookOpen, Users, TrendingUp, Gauge, Activity } from "lucide-react";

const FEATURES = [
  [Network, "Viable System Model", "Modelleer je organisatie recursief in het Circumplex VSM: Systemen I t/m V, afdelingen, teams en medewerkers op elk niveau, met doelen die van Raad van commissarissen tot werkvloer doorlopen."],
  [BookOpen, "Strategie\u00ebn & gedragshandboek", "Leg alle strategie\u00ebn vast met het concrete, MARCO-gecontroleerde gedrag eronder. Zo ontstaat vanzelf een handleiding voor alles wat je organisatie doet, met beeld en video en te downloaden als PDF."],
  [Users, "Vaardigheden in kaart", "Koppel gedrag als vaardigheid aan medewerkers en zie direct waar een doel of strategie een vaardigheid vraagt die nog ontbreekt."],
  [TrendingUp, "Prestatie Verbeter Plan (OBM)", "Verbeter prestaties met Organizational Behavior Management: een begeleide PVP-wizard met pinpoint, meetplan, nulmetingen, interventies, subdoelen en een AI-managementsamenvatting."],
  [Gauge, "Belasting van medewerkers", "Per subdoel de verwachte belasting van opdrachtgever en opdrachtnemer, naast hoe het werkelijk ging. Overzicht per systeem, afdeling en medewerker."],
  [Activity, "Pijn/plezier-meter", "Medewerkers laten zelf weten hoe het gaat: gestresst, neutraal of ontspannen. Management ziet het verloop per afdeling over de weken."],
];

export const LandingFeatures = () => (
  <section className="border-t border-zinc-900" data-testid="landing-features">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-28">
      <div className="grid lg:grid-cols-[1fr_2fr] gap-12 mb-16">
        <div className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500">Meer dan een model</div>
        <h2 className="font-grotesk text-3xl sm:text-4xl font-bold tracking-tight leading-tight">
          Niet alleen je structuur, maar alles wat je organisatie doet, kan en voelt. In één samenhangend beeld.
        </h2>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 border-l border-t border-zinc-900">
        {FEATURES.map(([I, t, d], i) => (
          <div key={t} className="border-r border-b border-zinc-900 p-8 group hover:bg-zinc-900 hover:text-white transition-colors duration-300" data-testid={`landing-feature-${i}`}>
            <div className="flex items-center justify-between mb-10">
              <I className="h-6 w-6" strokeWidth={1.5} />
              <span className="font-mono text-xs text-zinc-400">{String(i + 1).padStart(2, "0")}</span>
            </div>
            <h3 className="font-grotesk text-xl font-bold mb-3">{t}</h3>
            <p className="text-sm leading-relaxed text-zinc-600 group-hover:text-zinc-300 transition-colors">{d}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
